import { ItemAliasType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemAliasUpdateAtom = createMutationAtomFactory(
  'settings.itemAliasUpdate',
  (params: {
    id: string;
    aliasName?: string | null;
    aliasCode?: string | null;
    aliasType?: ItemAliasType | null;
    notes?: string | null;
  }) => ({
    tradeItemAliasUpdate: {
      __args: {
        id: params.id,
        input: {
          aliasName: params.aliasName,
          aliasCode: params.aliasCode,
          aliasType: params.aliasType,
          notes: params.notes,
        },
      },
      id: true,
      aliasName: true,
      aliasType: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
